module.exports = __webpack_public_path__ + "static/media/hamburger.cecc3028.svg";